import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    scrollTop:0,
    // 英语，越南语，印尼语，泰语，俄罗斯语，阿拉伯语，西班牙语
    imgurl:'',//https://admin.qrf-alloy.com/
    nowstrLanguage:window.localStorage.getItem("nowstrLanguage")?(JSON.parse(window.localStorage.getItem("nowstrLanguage"))):{
        label:'English',
        value:1,
        icon:require('../assets/nav/en.png')
    },
    nowLanguage:window.localStorage.getItem("selLanguage")?window.localStorage.getItem("selLanguage"):'1',
    // 侧边栏信息
    navInfo:{
        Email:null,
        Tel:null,
        Wechat:null,
        WhatsApp:null,
        WechatCode:null
    },
    qrcode:[],
    LangTypeList: [
        { label: "English", value: 1,
            icon:require('../assets/nav/en.png')
         },
        { label: "Vietnam", value: 2,
        icon:require('../assets/nav/yuenan.jpeg')
         },
        { label: "Indonesia", value: 3,
        icon:require('../assets/nav/yinni.jpeg')
         },
        { label: "Thailand", value: 4,
        icon:require('../assets/nav/taiguo.jpeg')
         },
        { label: "Russia", value: 5,
        icon:require('../assets/nav/eluosi.jpeg')
         },
        { label: "Arab", value: 6,
        icon:require('../assets/nav/alabo.jpeg')
         },
        { label: "Spain", value: 7,
        icon:require('../assets/nav/xibanya.jpeg')
         },
    ],
    typeList:[],
    menuData:[],
    videoBrand:[],
    newsBrand:[],
    contactBrand:[],
    freeBrand:[]
}
export default new Vuex.Store({
    state
})